const getters = {
  cartLoaded: (state) => state.cartLoaded,
  cart: (state) => state.cart
};
export default getters;
